import { Directive, HostBinding, HostListener } from '@angular/core'

@Directive({
    selector: '[productKeyMask]'
})
export class ProductKeyDirective {
    @HostBinding('style.border')
    border: string;

    @HostListener('input', ['$event'])
    onKeyDown(event: any) {

        const input = event.target as HTMLInputElement;
        let trimmed = input.value.replace(/-/g, '');
        if (trimmed?.length === 23) {
            trimmed = trimmed.substr(0, 23);
        }
        let numbers: any[] = [];
        for (let i = 0; i < trimmed?.length; i += 5) {
            numbers.push(trimmed.substr(i, 5));
        }
        const caretPosition = event.target.selectionStart;
        setTimeout(() => {
            event.target.setSelectionRange(caretPosition, caretPosition);
        }, 0);
        input.value = numbers.join('-');
    }
}